import * as Icons from "heroicons-react";
import { useProductSearchCatQuery } from "../../../../services/productApi";
import { useEffect } from "react";
import productPhoto from "../../../../product.jpg";
import { signInUser } from "../../../Utility/Auth";
import { useDispatch, useSelector } from "react-redux";
import { addToCartReducer } from "../../../../features/posSlice";

const PosCart = ({ categoryId, query, setQuery }) => {
  const auth = signInUser();
  const aamarId = auth?.aamarId;
  const warehouse = auth?.warehouse;
  const { storeSettings = {} } = auth || {};
  const dispatch = useDispatch();

  const posSliceData = useSelector((state) => state.posReducer);

  // console.log("POS DATA::", posSliceData)

  const activeCategoryId =
    !categoryId || categoryId === "null" || categoryId === "undefined"
      ? "allCat"
      : categoryId;
  const activeQuery = !query || query === "" ? "all" : query;

  const { data, isSuccess, isFetching, isLoading, refetch } =
    useProductSearchCatQuery({
      categoryId: activeCategoryId,
      query: activeQuery,
      aamarId,
      warehouse,
    });

  // console.log("pos carts DATA",data,categoryId, query )
  useEffect(() => {
    // console.log("carts Effect",categoryId, query )
    if (query === "") {
      setQuery("all");
    }
    if (refetch) {
      refetch();
    }
  }, [categoryId, query]);

  // console.log("POS3 Search Data",data)

  return (
    <div className="mt-4 row">
      {isLoading || isFetching ? (
        <div className="col-12 text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading products...</p>
        </div>
      ) : data?.length > 0 ? (
        data.map((pro) => {
          return (
            <div className="p-2 rounded col-2 mb-4" key={pro._id}>
              <div
                className="mx-auto rounded-md "
                style={{
                  cursor: "pointer",
                  transition: "all 0.3s ease-in-out", // Smooth transition for hover effects
                }}
                onMouseEnter={(e) => {
                  //  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
                  //  e.currentTarget.style.border = "2px solid rgba(0, 0, 0, 0.2)"; // Bootstrap primary color
                }}
                onMouseLeave={(e) => {
                  //  e.currentTarget.style.boxShadow = "none";
                  //  e.currentTarget.style.border = "none";
                }}
              >
                <div>
                  {/* {console.log(pro)} */}
                  <img
                    style={{
                      borderRadius: "5px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      pro?.photo
                        ? `${
                            process.env.REACT_APP_PHOTO_URL
                          }${encodeURIComponent(pro.photo)}`
                        : productPhoto
                    }
                    alt="Product"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = productPhoto;
                    }}
                  />
                </div>
                <p
                  className="fs-6 mt-2 fw-normal mb-1"
                  style={{ width: "100%", height: "10%"}}
                >
                  {pro.name}
                </p>
                {/* {pro?.category && <p className="fs-6 text-muted">{pro?.category?.name}</p>} */}
                <div className="row">
                  <p className="fw-bold fs-6 col-7">
                    {pro?.priceList[0]?.mrp}{" "}
                    <small className="fs-xs fw-light">৳</small>
                    {/* 
              TODO:: Create dynamic currancy for all country and use dynamic symbol here
              <small className="fs-xs fw-light">{storeSettings?.currency}</small> 
             */}
                  </p>
                  <p className="fs-6 col-5 fw-light">
                    {pro?.stock || 0}{" "}
                    <small className="fs-xs col-5 fw-lighter">
                      {pro?.unit || ''}
                    </small>
                  </p>
                </div>
                <div className="w-full">
                  <button
                    onClick={() =>
                      dispatch(
                        addToCartReducer({
                          data: pro,
                          price: pro.priceList[0]._id,
                          qty: 1,
                        })
                      )
                    }
                    // onClick={()=> dispatch(addToCartReducer(pro))}
                    type="button"
                    className="btn btn-outline-dark btn-sm btn-block w-100 "
                  >
                    Add To Cart
                  </button>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p>No Product Found</p>
      )}
    </div>
  );
};

export default PosCart;
